import NextLink from 'next/link'
import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Image,
  Text,
  Box,
  useColorModeValue,
  Button,
} from "@chakra-ui/react"
import { useTranslations } from 'next-intl'
import { CALENDLY_LINK } from '@/constants'
import { PhoneCallIcon } from '@/components/icons/PhoneCallIcon'

interface ContactSalesModalForm {
  isOpen: boolean
  onClose: () => void
}

export const ContactSalesModal = ({
  isOpen,
  onClose,
}: ContactSalesModalForm) => {
  const t = useTranslations()

  return (
    <Modal
      size={{ base: 'sm', md: 'md' }}
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent borderRadius="8px">
        <ModalCloseButton />
        <ModalBody>
          <Center flexDirection="column" my="32px">
            <Image
              src="/img/contact-sales-modal.png"
              alt="Contact Sales"
              w="93px"
              h="93px"
            />
            <Text
              fontSize="24px"
              fontWeight="600"
              mt="20px"
            >
              {t('contact-sales.thanks-reaching-out')}
            </Text>
            <Text mt="8px">
              {t('contact-sales.team-will-be-in-touch')}
            </Text>
            <Box
              bg={useColorModeValue('blackAlpha.50', 'whiteAlpha.50')}
              textAlign="center"
              borderRadius="6px"
              w="full"
              p="16px"
              mt="20px"
            >
              <Text fontWeight="600">
                {t('contact-sales.set-time')}
              </Text>
              <Text>
                {t('contact-sales.book-free-call')}
              </Text>
              <NextLink href={CALENDLY_LINK} passHref>
                <Button
                  as="a"
                  target="_blank"
                  rel="noopener noreferrer"
                  bg="brand.600"
                  w="full"
                  mt="16px"
                  gap={2}
                  colorScheme="blue"
                  color="white"
                >
                  {t('contact-sales.book-call')}
                  <PhoneCallIcon/>
                </Button>
              </NextLink>
            </Box>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
